import { render, staticRenderFns } from "./SellerDetail.vue?vue&type=template&id=20245180"
import script from "./SellerDetail.vue?vue&type=script&lang=js"
export * from "./SellerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports